
webpack.register(
    'modules/history-experience-timeline/history-experience-timeline',
    function() {
        return import('modules/history-experience-timeline/history-experience-timeline');
    },
    true
);